<template>
   <HeaderDash />
   <SideMenu /> 
   <ContentWeekly /> 
</template>

<script>
// Importando los componententes pertenecientes a esta vista
import HeaderDash from '@/components/worker/dashboard/HeaderDash.vue'
import SideMenu from '@/components/worker/dashboard/SideMenu.vue'
import ContentWeekly from '@/components/worker/dashboard/modules/report/weekly/ContentWeekly.vue'

export default 
{
  name: 'Weekly',
  components: 
  {
    HeaderDash,
    SideMenu,
    ContentWeekly
  }
}
</script>

<style>



</style>